export default __webpack_public_path__ + "static/media/pikachu.296c98b1.gif";